var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 pb-12"},[_c('v-row',{staticClass:"px-3 fill-height"},[_c('v-col',[_c('v-alert',{attrs:{"type":"success"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.message)+"\n\t\t\t\t")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }